import React, { useState, useContext } from "react";
import { getDatosReserva } from "../components/getData";
import { FormContext } from "../context/FormContext";

const Reprogramar = ({ nextStep, prevStep, setDatosReserva  }) => {
  const {formData} = useContext(FormContext)
  const [dni, setDni] = useState(""); // Estado para el DNI
  const [idReserva, setIdReserva] = useState(""); // Estado para el ID de la reserva
  const [error, setError] = useState(null); // Estado para manejar errores
  const [loading, setLoading] = useState(false); // Estado para manejar la carga
 // Estado para guardar los datos de la reserva

  const handleBuscar = async (e) => {
    e.preventDefault(); // Evita que el formulario recargue la página
    setError(null);
    setLoading(true);

    try {
      const datos = await getDatosReserva(dni, idReserva); // Llama a la función con los valores
      setDatosReserva(datos); // Guarda los datos obtenidos en el estado
      // console.log("datos de reserva", datos)
      nextStep(); // Avanza al siguiente paso
    } catch (error) {
      setError("Error al buscar la reserva. Verifica los datos ingresados."); // Muestra un mensaje de error
    } finally {
      setLoading(false); // Detiene el indicador de carga
    }
  };


  const handleInputChange = (e) => {
    const value = e.target.value;

    // Limitar a números y máximo 8 caracteres
    if (value.length <= 8) {
      setDni(value);
    }

    // Limpiar el error si se corrige el valor
    if (value.length >= 7 && value.length <= 8) {
      setError("");
    }
  };

  const handleBlur = () => {
    // Validar longitud al salir del campo
    if (dni.length < 7 || dni.length > 15) {
      setError("El DNI debe tener entre 7 y 15 caracteres.");
    } else {
      setError("");
    }
  };

  return (
    <>
      <div className="row" id="booking">
        <div className="container">
          <div className="row mb40" id="booking-step-back">
            <button onClick={prevStep}>
              <i className="fa fa-long-arrow-left"></i>
              &nbsp; VOLVER
            </button>
          </div>
          <div className="row justify-content-center">
            <div
              className="col-md-9 pads0-768"
              id="search-appointment"
              style={{}}
            >
              <div className="row" id="search-form-container">
                <div className="col-12 mb40 text-center">
                  <h5 className="mb40">
                    Si deseas <b>anular o reprogramar tu cita</b>, ingresa aquí
                    los datos de búsqueda:
                  </h5>
                </div>
                <div className="col-12 pads0">
                  <form className="search-appointment-form" onSubmit={handleBuscar}>
                    <div className="row">
                      <div className="col-lg-4 offset-lg-2 col-md-6 col-12 mb20-768">
                        <p className="mb5">N° documento de identidad (*)</p>
                        <input
                          type="text"
                          className="search-info-input search-form-dni"
                          maxLength={15} // Limita la longitud máxima a 15 caracteres
                          minLength={7} // Limita la longitud mínima a 7 caracteres
                          value={dni}
                          onChange={(e) => setDni(e.target.value)} // Actualiza el estado del DNI
                          required
                          // onBlur={handleBlur} // Validar al perder el foco
                        />
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <p className="mb5">N° de cita (*)</p>
                        <input
                          type="text"
                          className="search-info-input search-form-id"
                          value={idReserva}
                          onChange={(e) => setIdReserva(e.target.value)} // Actualiza el estado del ID de la reserva
                          required
                        />
                      </div>
                      <div className="col-md-4 offset-lg-2 col-12 mt40">
                        <button
                          type="submit"
                          className={`src-button searchform-submit upper mb10 ${formData?.cadena === "eco" ? "reagendar-eco-button" : ""}
                          ${formData?.cadena === "gmo" ? "reagendar-gmo-button" : ""}
                          `}
                          disabled={loading} // Desactiva el botón si está cargando
                        >
                        
                          {loading ? "Buscando..." : "Buscar cita"}
                        </button>
                        <p>
                          * <i>Campos obligatorios</i>
                        </p>
                      </div>
                    </div>
                  </form>
                  {error && (
                    <div className="col-12 mt20 text-center text-danger">
                      {error}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reprogramar;
